import classNames from '../../utils/classNames'

// Placeholder bar colour: contrasts against the message row in both themes.
const bar = 'bg-secondary-txt-50 dark:bg-tertiary rounded'

// A single inbox message placeholder. Mirrors the Message layout (title + time
// row, then a content preview line) with the same `py-3 px-4` padding and
// `mb-[10px]` gap, so its height matches a real message row.
const InboxMessageSkeleton = () => (
  <div className="mb-[10px] rounded-md overflow-hidden animate-pulse">
    <div className="py-3 px-4 bg-secondary xl:bg-primary">
      <div className="flex justify-between items-center mb-[10px] pl-1">
        <div className={classNames('h-[18px] w-1/2', bar)} />
        <div className={classNames('h-[15px] w-16', bar)} />
      </div>
      <div className="pl-1">
        <div className={classNames('h-[15px] w-3/4', bar)} />
      </div>
    </div>
  </div>
)

// Renders `count` message placeholders in place of the spinner while the inbox
// list loads.
const InboxMessageListSkeleton = ({ count = 5 }: { count?: number }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <InboxMessageSkeleton key={i} />
    ))}
  </>
)

export default InboxMessageListSkeleton
